module.exports = __webpack_public_path__ + "static/media/loading1.717b642b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loading1.gif
// module id = 1262
// module chunks = 0